export default __webpack_public_path__ + "static/media/1-11@2x.df6bd2ab.png";